import PatientForm from '../../../../components/authorised/appointment/PatientForm'
import * as $ from 'jquery';
import { API_VERSION_ONE, handleAPI } from '../../../../itrust_common/utils/apiUtils';
import { quickActions } from '../../../../redux/actions/dashboard/quickActionActions';
import { useDispatch } from 'react-redux';

export default function PatientFullMode(props) {
  const { patient } = props
  const dispatch = useDispatch()

  const handleOnPatientSelect = async (id) => {
    const url = `/${API_VERSION_ONE}/patients/${id}`;
    let res = await handleAPI(url, {}, 'GET')
    return res.data.patient
  }

  const handlePatientFullModeClose = () => {
    $('#fullModePatient-modal').modal('hide')
    patient.id && handlePatientSelect(patient.id)
  }

  const handlePatientSelect = async (id) => {
    let patient = await handleOnPatientSelect(id)
    dispatch(quickActions({ selected_patient_id: id, patient: patient }))
  }

  return (
    <div>
      <div className="modal fade" id="fullModePatient-modal" tabIndex="-1" role="dialog" aria-labelledby="modalTitle" aria-hidden="true">
        <div className="modal-dialog m-0 min-width-full" role="document">
          <div className="modal-content bg-light">
            <div className='py-4 px-6 d-flex justify-content-end patient-full-mode-head position-fixed z-index-9'>
              <button className='btn btn-primary' onClick={handlePatientFullModeClose}>Close</button>
            </div>
            <PatientForm wrapperClasses="w-100" isQuickAction={true} />
          </div>
        </div>
      </div>
    </div>
  )
}